const HOTEL_SEARCH_URL = '/website/api/hotels/search/';
const DEFAULT_TIMEOUT_MS = 10000;

function parseJsonSafely(rawText) {
  if (!rawText) return {};
  try {
    const parsed = JSON.parse(rawText);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export async function fetchHotelSuggestions(query, limit = 8) {
  const normalizedQuery = String(query || '').trim();
  if (normalizedQuery.length < 3) return [];

  const safeLimit = Math.min(10, Math.max(1, Number(limit) || 8));
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), DEFAULT_TIMEOUT_MS);

  try {
    const response = await fetch(HOTEL_SEARCH_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: normalizedQuery,
        limit: safeLimit,
      }),
      signal: controller.signal,
      credentials: 'same-origin',
      cache: 'no-store',
    });

    const rawText = await response.text().catch(() => '');
    const payload = parseJsonSafely(rawText);
    if (!response.ok) {
      throw new Error(payload?.message || payload?.detail || 'Unable to fetch hotel suggestions right now.');
    }

    return Array.isArray(payload.results) ? payload.results : [];
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error('Hotel search timed out.');
    }
    throw error;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
